const context = require.context('@', true, /\/ru-RU\/.*\.js$/)

const locales = context.keys().reduce((acc, key) => {
  const module = context(key)
  if (module && module.default) {
    return { ...acc, ...module.default }
  }
  return acc
}, {})

export default {
  'ec.global.form.search.placeholder': 'Интеллектуальные ответы, помощь ассистента',
  'ec.global.form.search.text': 'Поиск',
  'ec.global.button.text.cancel': 'Отменить',
  'ec.global.button.text.confirm': 'Определение',
  'ec.global.button.text.submit': 'Представлено',

  'ec.retrieval.dialog.title': 'Быстрый поиск',
  'ec.retrieval.dialog.form.input.placeholder': 'Введите « / » или ключевое слово для быстрого поиска',
  'ec.retrieval.dialog.empty.description': 'Нет результатов поиска',

  'ec.error.notice.detail.text.404': 'Извините, страница, которую вы посетили, не существует',
  'ec.error.notice.detail.text.500': 'Извините, сервер ошибся.',
  'ec.error.notice.detail.text.403': 'Извините, у вас нет прав доступа к этой странице',
  'ec.error.notice.button.text': 'Извините, у вас нет прав доступа к этой странице',

  //首页内容
  'ec.home.name':'Главная страница',
  'ec.home.content': 'Новый район Харбина и зона свободной торговли являются важной несущей платформой для реализации национальной стратегии сотрудничества с Россией, обслуживая предприятия нового района, предприятия Лунцзяна и отечественные предприятия « выходит», помогая предприятиям с иностранными инвестициями « внедрять» и содействовать повышению качества и эффективности торгово - экономического сотрудничества с Россией。',
'ec.home.notice':'Объявление',
    'ec.home.noticemore':'Узнать больше',
    'ec.home.channel.ckts':'Возмещение экспортных пошлин',
    'ec.home.channel.yhjs':'Банковские расчеты',
    'ec.home.channel.bgfw':'Таможенные услуги',
    'ec.home.more':'Больше.',
    'ec.home.viewDetail':'подробность',
    'ec.home.detail':'подробность',
    //首页 业务专区
    'ec.home.business.title':'Оперативный район',
    'ec.home.business.zwfw.title':'Государственные службы',
    'ec.home.business.zwfw.content':'Вопросы государственной службы, включая административные полномочия по заявкам。',
    'ec.home.business.zwfw.qyfw':'Услуги по регистрации предприятий',
    'ec.home.business.zwfw.hyfw':'Отраслевые лицензионные услуги',
    'ec.home.business.zwfw.wjfw':'Услуги для иностранцев',
    'ec.home.business.ggfw.title':'Государственные службы',
    'ec.home.business.ggfw.content':'Услуги по удовлетворению потребностей граждан в жизни, работе и развитии.',
    'ec.home.business.ggfw.zcfw':'Консультативные услуги по вопросам политики',
    'ec.home.business.ggfw.zjfw':'Посреднические услуги',
    'ec.home.business.zxfw.title':'Специальные услуги',
    'ec.home.business.zxfw.content':'Специальные услуги для торговли с Россией.',
    'ec.home.business.zxfw.swflfw':'Юридические услуги за рубежом',
    'ec.home.business.zxfw.hwrzfw':'Зарубежные сертификационные услуги',
    'ec.home.business.zxfw.swjrfw':'Внешние финансовые услуги',
    'ec.home.business.zxfw.kjdsfw':'Трансграничные услуги электронной коммерции',
    'ec.home.business.zxfw.wyrcfw':'Служба иностранных языков',

    'ec.home.business.wmfw.title':'Услуги ВЭД',
    'ec.home.business.wmfw.content':'Помогите предприятиям осуществлять импортный и экспортный бизнес более удобно, эффективно и с низкими затратами.',

    'ec.home.dezc.title':'Политика в отношении России',
    'ec.home.gzdt.title':'Динамика работы',
    //首页 交流对接
    'ec.home.jldj.title':'стыковка переменного тока',
    'ec.home.jldj.qygxfb':'Спрос и предложение предприятий',
    'ec.home.jldj.cpcxfb':'Закупка и продажа продукции',
    'ec.home.jldj.dcwj':'Маркетинговые исследования',
    'ec.home.jldj.jlhbm':'Инвестиционное консультирование',
    'ec.home.jldj.qygxfb.desc':'Предоставьте предприятиям платформу для отображения и публикации информации о спросе. Компании могут публиковать информацию о спросе или предложении собственной продукции, чтобы найти потенциальных партнеров или клиентов.',
    'ec.home.jldj.cpcxfb.desc':'Разместите информацию о товарах, которые вам нужно приобрести, или о товарах, которые вы хотите продать, чтобы вы могли найти поставщиков или клиентов.',
    'ec.home.jldj.dcwj.desc':'Предоставляйте каналы маркетинговых исследований, получайте отзывы о рынке и помогайте предприятиям повышать конкурентоспособность на рынке.',
    'ec.home.jldj.jlhbm.desc':'В сочетании с таможенными данными об импорте и экспорте и данными об иностранных покупателях он помогает пользователям получить глубокое понимание тенденций международной торговли, динамики импорта и экспорта, а также потенциальных инвестиционных возможностей.',

    //首页 政务地图
    'ec.home.zwdt.title':'Карта правительства',
    'ec.home.zwdt.line':'Оффлайн.',
    'ec.home.zwdt.here':'Иди сюда.',
    'ec.home.zwdt.name':'Новый Харбинский центр комплексного обслуживания и зоны свободной торговли для России',
    'ec.home.zwdt.phone':'0451-88888888',
    'ec.home.zwdt.address':'Харбин, район Сунбэй, улица Чжигу, 288',
    'ec.home.zwdt.time':'Понедельник - пятница (за исключением официальных праздников) 8: 00 - 17: 00',
    'ec.home.zwdt.bus':'Сядьте на автобусы No 3, No 6 и No 146 до Российского комплексного сервисного центра.',

    //首页 大厅专区
    'ec.home.hall.title':'Зал',
    'ec.home.hall.vr':'Виртуальный зал VR',
    'ec.home.hall.ai':'Умные вопросы и ответы.',
    'ec.home.hall.video':'Видеоматериалы',

    //二级页面标题内容
    'ec.home.news.title':'Рабочая деятельность',
    'ec.news.content':'Последние данные о работе Центра комплексного обслуживания в России',
    'ec.tzgg.title':'Уведомление',
    'ec.tzgg.content':'Уведомление о Центре комплексного обслуживания сотрудничества Харбинской ЗСТ в новом районе Харбина с Россией.',

    //二级页面中介超市
    'ec.market.title':'Посреднический супермаркет',
    'ec.market.content':'Онлайновые платформы для объединения различных посреднических услуг.',
    'ec.market.search.name':'Название посреднической службы',
    'ec.market.search.fw':'Сфера деятельности',
    'ec.market.search.button.search':'Запрос',
    'ec.market.search.button.reset':'Сбросить',

    'ec.policy.title':'Политика в отношении России',
    'ec.policy.content':'Презентация политики России и России. Цзе',

    //首页特色服务
    'ec.home.service.title': 'Особые услуги',

    'ec.home.publish.time':'Освобожденный',
    'ec.home.view.time':'Представления',
    'ec.home.times':'раз',
    'ec.home.font':'шрифт',
    'ec.home.font.large':'большой',
    'ec.home.font.middle':'середина',
    'ec.home.font.small':'маленький',

    // 涉外法律服务
    'ec.home.business.zxfw.swflfw.content':'Содержание услуги',
    'ec.home.business.zxfw.swflfw.depart':'Несущий механизм',
    'ec.home.business.zxfw.swflfw.region':'Сфера деятельности',
    'ec.home.business.zxfw.video.consultation':'Видеоконсультация',
  'ec.home.business.zxfw.consultation':'консультация',
...locales,
}
